import { createContext } from 'react';
import type { CalendarInteractionContextProps } from './CalendarInteractionProvider.types';

export const CalendarInteractionContext =
  createContext<CalendarInteractionContextProps>({
    pasteEvent: () => undefined,
    addAppointment: () => undefined,
    deleteAppointment: () => undefined,
    updateAppointment: () => undefined,
    duplicateEvent: () => undefined,
    duplicateRecurringEvent: () => undefined,
    exportAppointmentSeries: () => undefined
  });
